module.exports = __webpack_public_path__ + "img/table.42c0f5cb.png";